import { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import { clone } from '../../../utils';
import classnames from 'classnames';

class FormCheckBox extends Component {

    onChange(e) {
        let response = clone(this.props.question);
        response.value_choice = e.target.checked;
        response.deleted = !e.target.checked;
        this.props.responseValueChange(response);
        if (typeof this.props.save === "function") {
            this.props.save();
        }
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        let checkboxElement = this.props.inputProperties.singlechoice ? 
            <Radio {...this.props.inputProperties}
                checked={this.props.question.value_choice} onChange={this.onChange.bind(this)}
                className={classnames(this.props.inputProperties.className, "small-checkbox", (this.props.inputProperties.disabled ? "light-disabled" : ""))} />
            : <Checkbox {...this.props.inputProperties}
                checked={this.props.question.value_choice} onChange={this.onChange.bind(this)}
            className={classnames(this.props.inputProperties.className, "small-checkbox", (this.props.inputProperties.disabled ? "light-disabled" : ""))} />

        return (
            <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                {this.props.metaQuestion.answer ? (
                    <>
                        <div className="col-lg-9 col-md-9 col-sm-9 col-9 without-padding label-ellipsis">
                            <span>{this.props.metaQuestion.answer}</span>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3 without-padding">
                            checkboxElement
                        </div>
                    </>
                ) : (
                    <div className={classnames(
                        "center",
                        (this.props.inputProperties.centerfield ? "center-content"  : ""))
                    }>
                        {checkboxElement}
                    </div>
                )}

            </div>
        )
    }
}

export default FormCheckBox;
